define('lisCreateEditLayoutView',[
  'module',
  'marionette',
  'backbone',
  'dialogFormView',
  'template!lisCreateEditLayoutTpl',
  'savingBehavior',
  'bootbox',
  'underscore',
  'app',
  'settings',
  'autocompleteView',
  'colorUtils'
], function(
  module,
  Marionette,
  Backbone,
  DialogFormView,
  createEditLayoutTpl,
  SavingBehavior,
  bootbox,
  _,
  App,
  Settings,
  AutocompleteView,
  ColorUtils
) {
  'use strict';

  var CreateEditLayoutView = DialogFormView.extend({
    template: createEditLayoutTpl,

    ui: {
      input: '.js-info-input',
      colorBtn: '.colorpick'
    },

    events: {
      'click .js-cancel-popup': 'hide',
      'focus @ui.input' : 'onFocus',
      'change @ui.input': 'onInputChange',
      'click .js-confirm': 'onConfirm',
      'click @ui.colorBtn' : 'onShowColorpicker'
    },

    regions: {
      selectLisResGr: '.js-select-lisresgr-region',
      selectLisResGrCh2: '.js-select-lisresgrch2-region'
    },

    behaviors: {
      Saving: {
        behaviorClass: SavingBehavior
      }
    },

    modelEvents: {
      sync: 'onSave',
      error: 'onSaveError'
    },

    fieldsToValidate: [
      {name: 'code', type: 'required'},
      {name: 'name', type: 'required'}
    ],

    initialize: function(options) {
      this.model = options.lisModel.clone();
    },

    serializeData: function() {
      var templateData = this.model.toJSON();
      templateData.newItem = this.options.newItem;
      templateData.colorHexa = ColorUtils
          .decimalToHexa(this.model.get('matColor'))
          .split('#')[1];
      return templateData;
    },

    onShow: function() {
      $.material.init();
      this.triggerMethod('enable:cancel:confirm');
    },

    onShowColorpicker: function(event) {
      var that = this,
          target = $(event.currentTarget),
          newColor;

      target.colorpicker();
      target.colorpicker('show');
      target.on('changeColor.colorpicker', function(event){
        newColor = event.color.toRGB();
        that.model.set('matColor', ColorUtils.rgbToDecimal(newColor.r, newColor.g, newColor.b));
      });
    },

    onConfirm: function() {
      if(this.validate(this.fieldsToValidate)) {
        this.model.save();
      }
    },

    _getLisResGrsAutocompleteOptions: function(property) {
      var lisResGr = this.model.get(property);
      return {
        type: 'remote',
        remote: Settings.url('compuzz', 'v2/lisresgrs'),
        valueKey: 'code',
        apiKey: 'secId',
        placeholder: _.i18n('selectlisresgr.placeholder'),
        value: lisResGr ? lisResGr.code : null,
        name: property,
        onPressKey: true,
        lazyLoad: true,
        keys: {
          query: 'code',
          limit: 'pageSize'
        },
        callback: _.bind(this.onChangeLisResGr, this)
      };
    },

    onChangeLisResGr: function(fieldName, model) {
      if (model) {
        model.unset('autocompleteValue', {silent: true});
      }
      this.onChange(fieldName, model);
      this.triggerMethod('enable:cancel:confirm');
    },

    onSave: function(model) {
      var modelJSON = model.toJSON();
      this.options.lisModel.set(modelJSON);
      this.triggerMethod('saved');
      App.trigger('lis:header:rerender', modelJSON);
      App.navigate('admin/lis/' + model.get('secId'), {trigger: true});
      this.hide();
    },

    hide: function() {
      this.triggerMethod('hide');
      this.box.modal('hide');
      this.destroy();
      if (App.getCurrentRoute() ===  'admin/lis/new') {
        App.navigate('admin/lis', {trigger: true});
      }
    },

    onSaveError: function(model, response) {
      if(response.status === 409) {
        this.onDuplicateCode();
        this.triggerMethod('hide:label');
      }
    },

    onDuplicateCode: function() {
      this.ui.endUserIdInput.popover('show');
      this.ui.endUserIdInput.addClass('invalid');
      this.ui.endUserIdInput.closest('div[data-field-name=code').addClass('has-error');
    }
  });

  module.exports = CreateEditLayoutView;
});
